/* ============================================================
   IMENHOF BLOOM — refine.js
   AJAX-filteren op de collectie- en zoekpagina. Vinkjes, sorteren,
   prijs en filter-pillen verversen alleen het resultaatblok
   (#CollectionResults) in plaats van de hele pagina te herladen.
   Behoudt scrollpositie. Zonder dit script vallen de formulieren
   terug op gewone GET-submits (inline onchange-fallback).
   ============================================================ */
(function () {
  'use strict';
  var container = document.getElementById('CollectionResults');
  if (!container) return;                 // alleen op collectie-/zoekpagina
  var root = document.documentElement;
  root.classList.add('refine-js');        // schakelt de inline-submit fallback uit

  var busy = false;
  var io = null;

  function announce(message) {
    if (message && window.IMHAnnounce) window.IMHAnnounce(message);
  }

  function focusSafe(element) {
    if (!element || !element.focus) return;
    try { element.focus({ preventScroll: true }); } catch (e) { element.focus(); }
  }

  function captureFocus(source) {
    var active = source || document.activeElement;
    if (!active || !container.contains(active)) return null;
    return {
      tag: active.tagName,
      type: active.type || '',
      name: active.getAttribute('name') || '',
      value: active.value == null ? '' : String(active.value),
      href: active.tagName === 'A' ? (active.getAttribute('href') || '') : '',
      drawer: active.getAttribute('data-drawer-open') || '',
      loadMore: active.hasAttribute('data-load-more')
    };
  }

  function restoreFocus(state) {
    if (!state) return;
    var target = null;
    if (state.drawer) {
      target = Array.prototype.filter.call(container.querySelectorAll('[data-drawer-open]'), function (element) {
        return element.getAttribute('data-drawer-open') === state.drawer;
      })[0] || null;
    } else if (state.loadMore) {
      target = container.querySelector('[data-load-more]');
    } else if (state.name) {
      target = Array.prototype.filter.call(container.querySelectorAll('[name]'), function (element) {
        return element.tagName === state.tag && (element.type || '') === state.type && element.getAttribute('name') === state.name && String(element.value == null ? '' : element.value) === state.value;
      })[0] || null;
    } else if (state.href) {
      target = Array.prototype.filter.call(container.querySelectorAll('a[href]'), function (element) {
        return element.getAttribute('href') === state.href;
      })[0] || null;
    }
    if (!target) {
      container.setAttribute('tabindex', '-1');
      target = container;
    }
    focusSafe(target);
  }

  function resultMessage() {
    var count = document.querySelector('.coll-hero__count');
    if (count && count.textContent.trim()) return count.textContent.trim() + ' beschikbaar.';
    var progress = container.querySelector('.coll-more__count');
    if (progress && progress.textContent.trim()) return progress.textContent.trim() + '.';
    var empty = container.querySelector('.empty h2');
    if (empty && empty.textContent.trim()) return empty.textContent.trim() + '.';
    var cards = container.querySelectorAll('.product-grid .pcard').length;
    return cards + (cards === 1 ? ' resultaat getoond.' : ' resultaten getoond.');
  }

  /* ---- URL bouwen uit een filter-/sorteerformulier ---- */
  function urlFromForm(form) {
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (value, key) {
      if (String(value).trim() !== '') params.append(key, value);
    });
    var qs = params.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }

  /* ---- Verse kaarten direct tonen ----
     theme.js verbergt .reveal-elementen tot ze in beeld scrollen via een
     observer die alleen bij paginalading draait. Na een AJAX-swap moeten
     we de nieuw ingevoegde kaarten zelf zichtbaar zetten, anders staan ze
     er wel maar blijven ze onzichtbaar. */
  function reveal(scope) {
    scope.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
    var grid = scope.querySelector('.product-grid');
    if (grid) Array.prototype.forEach.call(grid.children, function (el) { el.classList.add('is-in'); });
  }

  /* ---- Oneindig laden (herbruikbaar; vervangt de versie in theme.js
          die op [data-infinite] zoekt; deze secties gebruiken [data-coll-more]) ---- */
  function initInfinite() {
    if (io) { io.disconnect(); io = null; }
    var more = container.querySelector('[data-coll-more]');
    if (!more) return;
    var grid = container.querySelector('.product-grid');
    var shownEl = more.querySelector('[data-shown]');
    var countText = more.querySelector('.coll-more__count');
    // Zoekresultaten hadden hier nog een tweede live-regio. De centrale
    // IMH-live-regio doet de melding, zodat dezelfde teller niet dubbel klinkt.
    if (countText) countText.removeAttribute('aria-live');
    var nextUrl = more.dataset.nextUrl;
    var loading = false;

    async function loadMore() {
      if (loading || !nextUrl || !grid) return;
      loading = true;
      more.classList.remove('is-loading', 'is-done');
      more.setAttribute('aria-busy', 'true');
      var moreBtn = more.querySelector('[data-load-more]');
      var originalLabel = moreBtn ? moreBtn.textContent : '';
      if (moreBtn) {
        moreBtn.setAttribute('aria-disabled', 'true');
        moreBtn.textContent = 'Resultaten laden…';
      }
      try {
        var r = await fetch(nextUrl);
        var html = await r.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('.product-grid > *').forEach(function (card) {
          card.classList.add('is-in');
          card.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
          grid.appendChild(card);
        });
        var next = doc.querySelector('[data-coll-more]');
        nextUrl = next ? next.dataset.nextUrl : '';
        if (shownEl) shownEl.textContent = grid.children.length;
        if (moreBtn) {
          if (nextUrl) {
            moreBtn.removeAttribute('aria-disabled');
            moreBtn.textContent = originalLabel;
          } else {
            moreBtn.setAttribute('aria-disabled', 'true');
            moreBtn.textContent = 'Alle resultaten zijn geladen';
          }
        }
        announce(countText && countText.textContent.trim() ? countText.textContent.trim() + '.' : 'Meer resultaten geladen.');
      } catch (e) {
        if (moreBtn) {
          moreBtn.removeAttribute('aria-disabled');
          moreBtn.textContent = originalLabel;
        }
        announce('Resultaten laden lukte niet. Probeer het opnieuw.');
      }
      loading = false;
      more.removeAttribute('aria-busy');
    }

    var moreBtn = more.querySelector('[data-load-more]');
    if (moreBtn) moreBtn.addEventListener('click', loadMore);
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) loadMore(); });
      }, { rootMargin: '700px 0px' });
      io.observe(more);
    }
  }

  /* ---- Resultaatblok verversen ---- */
  async function apply(url, push, scrollTop, focusSource) {
    if (busy) return;
    // Leg de actieve bediening vast voordat fetch/await de browser de kans
    // geeft om focus naar body te verplaatsen.
    var focusState = captureFocus(focusSource);
    busy = true;
    container.classList.add('is-filtering');
    container.setAttribute('aria-busy', 'true');
    try {
      var r = await fetch(url, { headers: { 'X-Requested-With': 'fetch' } });
      var html = await r.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('CollectionResults');
      if (!fresh) throw new Error('geen resultaatblok in respons');
      container.innerHTML = fresh.innerHTML;
      reveal(container);                  // verse kaarten direct zichtbaar maken
      restoreFocus(focusState);

      // Drawer-filters (staan buiten het resultaatblok) meeverversen
      var freshDrawer = doc.querySelector('#FilterDrawer .filters');
      var curDrawer = document.querySelector('#FilterDrawer .filters');
      if (freshDrawer && curDrawer) curDrawer.innerHTML = freshDrawer.innerHTML;

      // Teller in de hero meeverversen (collectiepagina)
      var freshCount = doc.querySelector('.coll-hero__count');
      var curCount = document.querySelector('.coll-hero__count');
      if (freshCount && curCount) curCount.textContent = freshCount.textContent;

      if (push) history.pushState({ refine: true }, '', url);
      initInfinite();
      if (scrollTop) {
        var top = container.getBoundingClientRect().top + window.scrollY - 90;
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
      }
      announce('Resultaten bijgewerkt. ' + resultMessage());
    } catch (e) {
      window.location.href = url;         // harde fallback bij netwerkfout
    }
    busy = false;
    container.classList.remove('is-filtering');
    container.removeAttribute('aria-busy');
  }

  /* ---- Live vinken + sorteren (desktop sidebar en sorteerkeuze) ---- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.type !== 'checkbox' && t.tagName !== 'SELECT') return;
    var form = t.closest('form[data-filter-form][data-filter-instant]');
    if (!form) return;
    apply(urlFromForm(form), true, false, t);
  });

  /* ---- Formulier verzenden (prijs "Toepassen", mobiele drawer) ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-filter-form]');
    if (!form) return;
    e.preventDefault();
    var inDrawer = form.closest('.drawer');
    apply(urlFromForm(form), true, !!inDrawer, e.submitter || document.activeElement);
    if (inDrawer) {
      var close = inDrawer.querySelector('[data-drawer-close]');
      if (close) close.click();           // hergebruik drawer-sluiting uit theme.js
    }
  });

  /* ---- Pillen wissen, "Wis alles" en actieve-filterlinks ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    if (!a.closest('#CollectionResults') && !a.closest('#FilterDrawer')) return;
    var dest;
    try { dest = new URL(a.href, location.origin); } catch (_) { return; }
    if (dest.pathname !== location.pathname) return;  // alleen filter-/sorteermutaties, geen productlinks
    e.preventDefault();
    apply(dest.pathname + dest.search, true, false, a);
    var inDrawer = a.closest('.drawer');
    if (inDrawer && dest.search === '') {
      var close = inDrawer.querySelector('[data-drawer-close]');
      if (close) close.click();
    }
  });

  /* ---- Terug-/vooruitknop ---- */
  window.addEventListener('popstate', function () {
    apply(location.pathname + location.search, false, false);
  });

  /* ---- Eerste paginalading: knop + observer meteen activeren ----
     Zonder deze aanroep werd initInfinite() pas na een filter-/sorteer-
     swap gestart, waardoor "Meer laden" op een verse collectiepagina
     geen klik-handler had en niets deed. */
  initInfinite();
})();
